module.exports = "/_next/static/images/Tatiana_Ilian-b929d2ee4afdf46d438abccda3b22837.webp";